import { Choice } from '../generated/types';
import { DeepPartial } from './deep-partial';
import { isValidDate } from './is-valid-date';

export function getChoiceContext(
  choice: DeepPartial<Choice>
): Record<string, string> {
  return {
    ...(isValidDate(choice.createdAt) ? { CREATED_AT: choice.createdAt } : {}),
    ...(isValidDate(choice.submittedAt)
      ? { SUBMITTED_AT: choice.submittedAt }
      : {}),
    ...(isValidDate(choice.approvedAt)
      ? { APPROVED_AT: choice.approvedAt }
      : {}),
    ...(isValidDate(choice.order?.completedAt)
      ? { COMPLETED_AT: choice.order?.completedAt }
      : {}),
    ...(choice.order?.externalId
      ? { EXTERNAL_ID: choice.order.externalId }
      : {})
  };
}
